import {
  Loading
} from "element-ui";
import _ from 'lodash';

let loading = null;
let requestCount = 0
let responseCount = 0


//关闭loading状态
const endLoading = _.debounce(() => {
  if (responseCount === requestCount) {
    loading?.close();
    loading = null;
  }
}, 300);


export const showScreenLoading = () => {
  requestCount++
  if (requestCount !== responseCount && !loading) {
    loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }
}

export const hideScreenLoading = () => {
  responseCount++
  endLoading()
}
export default {};